import { get } from 'lodash';

export const filters = state => get(state, 'form.taxTransactionsFilter.values');
